import React from "react";
import './AboutUs.css';
import aboutusperson from '../../Images/aboutus-prof-image.svg';
// import logo from '../../Images/stockport-logo.svg'
import badgelogo from '../../Images/about-logo.svg';
import teampeoples from '../../Images/grp-people-img.svg';
import stars from '../../Images/about-stars.svg';
import { customers } from "../companyDetails";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
    const navigate = useNavigate();

    return (
        <>
            <section className="about-us-section" id="aboutus">
                <div className="about-us-container">
                    <div className="about-us-left">
                        <img src={aboutusperson} alt='our team' className="about-us-image" />
                        <div className="image-logo-badge">
                            <img src={badgelogo} alt="logo" className="badge-image" />
                        </div>
                        {/* <p className="about-name">Mamatha</p> */}
                        {/* <div className="badge">
                        <div className="badge-left">
                            <span className="num-badge">{customers.length}+</span>
                            <span className="stars"><img src={stars} alt='stars' className="about-stars"/></span>
                        </div>
                        <div className="badge-right">
                            <img src={teampeoples} alt="team icon" className="badge-icon" />
                        </div>
                    </div> */}
                    </div>
                    <div className="about-us-right">
                        {/* <h5 className="aboutus-subtitle">Stockport Solutions</h5> */}
                        <h2 className="aboutus-title">About Us</h2>
                        <div className="aboutus-intro-container">
                            {/* <p className="aboutus-intro">Stockport Solutions FZ LLC is a Dubai-based startup offering integrated services across general trading, procurement logistics consulting, cargo freight advisory, and e-commerce enablement. Founded in 2025, we are committed to simplifying global commerce by connecting businesses with reliable supply chains, efficient freight solutions, and digital retail platforms.</p> */}
                        </div>
                        <p className="aboutus-description">Stockport Solutions FZ LLC is a Dubai‑based company offering integrated services across general trading, procurement logistics consulting, cargo freight advisory, freight forwarding, and e‑commerce enablement. Founded in 2025, we are committed to simplifying global commerce by connecting businesses with reliable supply chains, efficient freight solutions, and digital retail platforms.</p>
                        <p className="aboutus-description">Our freight forwarding division plays a central role in supporting clients with the seamless movement of goods across international markets. We provide comprehensive end‑to‑end solutions—including multimodal transportation, carrier coordination, customs documentation, consolidation services, and shipment tracking—to ensure cargo moves safely, efficiently, and cost‑effectively. By combining operational expertise with strategic planning, we help businesses navigate global logistics with clarity and confidence.</p>
                        <p className="aboutus-description">We are a dynamic, innovation‑driven organization dedicated to delivering high‑quality products and seamless operational solutions. We emphasize reliability, affordability, and value, ensuring that every product and service we provide meets the evolving needs of our clients.</p>
                        <p className="aboutus-description">Backed by a small but talented team, we focus on delivering exceptional service and building long‑term customer relationships. At Stockport Solutions, we believe in creating a positive impact within the industry through trust, transparency, and continuous improvement.</p>
                    </div>
                </div>
                <div class="explore-wrapper">
                    <div className="explore-banner-container">
                        <div className="explore-banner">
                            <p className="explore-banner-text">Discover the perfect products for your needs! Click below to explore our collection and find what suits you best.</p>
                        </div>
                        <div className="explore-banner-btn">
                            <button className="explore-product-btn" onClick={() => navigate('/products')}>Explore Product</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutUs